import React from 'react';
const coverage = [{
  label: 'Every session',
  body: 'A one-line premise, a cold open to read aloud, three flexible scenes and a cliffhanger'
}, {
  label: 'Every encounter',
  body: 'Scaled for 3 to 6 players, with 5E-compatible SRD creatures named, at High XP or below'
}, {
  label: 'Every character',
  body: 'Two personalization hooks per character, so each player gets a moment'
}, {
  label: 'Every ending',
  body: 'A re-booking hook built into the cliffhanger, so players want the next seat'
}, {
  label: 'Every table',
  body: 'Notes for your VTT and for in-person play, plus a list of the assets you need'
}, {
  label: 'Format',
  body: 'Landscape pages that read on a tablet or print for the table. Run it Monday online and Thursday in person'
}];
const steps = ['Open the volume', 'Read the Run Sheet', 'Make it yours', 'Run the table'];
export function ProductReveal() {
  return <section aria-labelledby="mechanism-heading" className="w-full border-y-4 border-gold bg-plum-mid" data-id="element-223" data-mp="1plyy3k9kvv5x">
      <div className="max-w-5xl mx-auto px-5 py-16 sm:py-20 text-center" data-id="element-224" data-mp="1f2115byclj6a">
        <p className="text-[11px] font-semibold uppercase tracking-[1.8px] text-gold" data-id="element-225" data-mp="1f06g7xn2tr27">
          The mechanism
        </p>
        <h2 id="mechanism-heading" className="mt-3 font-display font-semibold text-white text-3xl sm:text-5xl" data-id="element-226" data-mp="1osvo6ijf4mss">
          The Paid Table Loop
        </h2>
        <p className="mx-auto mt-5 max-w-2xl text-base sm:text-lg text-white/75" data-id="element-227" data-mp="w3otjun34hct">
          A full year of sessions in one repeatable format. Every session is a
          two-page Paid Table Loop: a one-page{' '}
          <span className="font-semibold text-white" data-id="element-228" data-mp="162dy6lpz05b4">Run Sheet</span> you read in
          about 20 minutes, and a one-page{' '}
          <span className="font-semibold text-white" data-id="element-229" data-mp="2ch54x61rykd2">Table Kit</span> with
          everything you need at the table. Situations, not plots, because
          players always go off-script.
        </p>

        <ol className="mx-auto mt-8 flex max-w-3xl flex-wrap items-center justify-center gap-2 sm:gap-3" data-id="element-230" data-mp="1rrkqsbamjtpb">
          {steps.map((step, i) => <li key={step} className="flex items-center gap-2 sm:gap-3" data-id="element-231" data-mp="1mw5idyvdyq0a" data-mpi={i}>
              <span className="rounded-full bg-gold/15 px-4 py-2 text-[13px] font-semibold text-gold-hover" data-id="element-232" data-mp="21qa9g6achi6m">
                <span className="mr-1.5 font-display" data-id="element-233" data-mp="1wpvzujt3i06h">{i + 1}.</span>
                {step}
              </span>
              {i < steps.length - 1 && <span className="hidden h-px w-5 bg-gold/50 sm:block" data-id="element-234" data-mp="144cmnwoxmqov" />}
            </li>)}
        </ol>

        <ul className="mt-9 grid gap-2.5 text-left sm:grid-cols-2 lg:grid-cols-3" data-id="element-235" data-mp="1itij5cwdy2t2">
          {coverage.map(item => <li key={item.label} className="rounded-xl border border-plum-line bg-white/5 px-4 py-3" data-id="element-236" data-mp="1dzmp2lj8t036">
              <span className="block text-[11px] font-semibold uppercase tracking-widest text-gold" data-id="element-237" data-mp="ldle2xcrr4bj">
                {item.label}
              </span>
              <span className="mt-1 block text-sm text-white/85" data-id="element-238" data-mp="2wyc85d4ywqhb">
                {item.body}
              </span>
            </li>)}
        </ul>
      </div>
    </section>;
}